import { Grid, TextField } from "@mui/material";

// The form fields for the Create User form
export default function CreateUserForm(props: any) {
  const { formik } = props;

  return (
    <Grid sx={{ mb: "5%" }} container spacing={2}>
      <Grid item xs={6}>
        <TextField
          fullWidth
          sx={{ mt: "2%" }}
          name="firstName"
          label="First Name"
          placeholder="Enter First Name"
          value={formik.values.firstName}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.firstName)}
          helperText={
            formik.errors.firstName ||
            `${formik.values.firstName.trim().length}/50`
          }
          required
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          sx={{ mt: "2%" }}
          name="lastName"
          label="Last Name"
          placeholder="Enter Last Name"
          value={formik.values.lastName}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.lastName)}
          helperText={
            formik.errors.lastName ||
            `${formik.values.lastName.trim().length}/50`
          }
          required
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          sx={{ mt: "2%" }}
          name="emailAddress"
          label="Email Address"
          placeholder="Enter Email Address"
          value={formik.values.emailAddress}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.emailAddress)}
          helperText={
            formik.errors.emailAddress ||
            `${formik.values.emailAddress.trim().length}/50`
          }
          required
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          sx={{ mt: "2%" }}
          name="phoneNumber"
          label="Phone Number"
          placeholder="Enter Phone Number"
          value={formik.values.phoneNumber}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.phoneNumber)}
          helperText={
            formik.errors.phoneNumber ||
            `${formik.values.phoneNumber.trim().length}/50`
          }
        />
      </Grid>
    </Grid>
  );
}
